<section class="m-4">
  <form *dynamicFormInfo="formInfo" (keyup.enter)="search()">
    <div class="row">
      <div class="col-12">
        <app-radio-input
          controlName="priorAuthorizationSearchTypeId"
          [fetchData]="parSearchTypes$"
          (richChange)="receiveSelectedParSearchType($event)"
          [hideLabel]="true"
        ></app-radio-input>
      </div>
    </div>
    <div *ngIf="isCustomSearchVisible">
      <div class="row">
        <div class="col-3">
          <app-text-input
            controlName="priorAuthSystemId"
            placeholder="PA-00-0000-000"
            [maskConfig]="priorAuthIdMaskConfig"
            (richBlur)="onPriorAuthSystemIdChanged($event)"
            (keydown)="updateParIdField($event)"
          ></app-text-input>
        </div>
        <div class="col-3">
          <app-select-input
            #priorAuthRequestTypeList
            controlName="priorAuthorizationRequestTypeId"
            [fetchData]="priorAuthRequestTypes$"
            placeholder="Select PAR Type"
          ></app-select-input>
        </div>
        <div class="col-3">
          <app-select-input
            #objectStatusList
            controlName="objectStatusId"
            [fetchData]="objectStatuses$"
            placeholder="Select PAR Status"
          ></app-select-input>
        </div>
        <div class="col-3">
          <app-text-input controlName="claimantLastName"></app-text-input>
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <app-text-input
            controlName="wCBCaseNumber"
            hint="Must be 8 characters in length"
          ></app-text-input>
        </div>
        <div class="col-3">
          <app-text-input controlName="claimAdminClaimNumber"></app-text-input>
        </div>
        <div class="col-3">
          <app-text-input controlName="insurerNumber"></app-text-input>
        </div>
        <div class="col-3">
          <app-text-input
            controlName="providerName"
            hint="Last, First OR SED Name"
          ></app-text-input>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-6">
          PAR Submission Date - Enter a date range to search for all PARs submitted within the
          range.
        </div>
        <div class="col-6">
          PAR Status Date - Enter a date range to search for all PARs submitted within the range.
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <app-generic-input controlName="parSubmissionDateFrom"></app-generic-input>
        </div>
        <div class="col-3">
          <app-generic-input controlName="parSubmissionDateTo"></app-generic-input>
        </div>
        <div class="col-3">
          <app-generic-input controlName="parStatusDateFrom"></app-generic-input>
        </div>
        <div class="col-3">
          <app-generic-input controlName="parStatusDateTo"></app-generic-input>
        </div>
      </div>
    </div>
    <div class="d-flex flex-row">
      <button
        type="button"
        class="mr-3 mt-3"
        color="primary"
        data-automation-id="prior-authorization-request-search_202126121531"
        mat-flat-button
        (click)="search()"
        [disabled]="!parSearchForm.valid || hasSearchInProgress"
        aria-label="Search"
      >
        <mat-icon *ngIf="!hasSearchInProgress">search</mat-icon>
        <span *ngIf="!hasSearchInProgress">Search</span>
        <mat-progress-spinner
          *ngIf="hasSearchInProgress"
          class="mat-progress-spinner"
          mode="indeterminate"
          diameter="20"
          aria-label="Search in progress"
        ></mat-progress-spinner>
      </button>
      <button
        type="reset"
        class="mat-simple-button mr-3 mt-3"
        color="primary"
        data-automation-id="prior-authorization-request-search_202126121535"
        mat-button
        (click)="resetForm()"
        [disabled]="hasSearched ? false : parSearchForm.pristine"
      >
        <mat-icon class="mat-icon--mirrored">refresh</mat-icon>
        Clear
      </button>
    </div>
  </form>
  <section class="mt-4" [hidden]="!hasSearched">
    <div>
      <span>Please Note:&nbsp;</span>
      <span *ngIf="!isCustomSearchVisible && datatableComponent?.filteredCount === dataTableLimit">
        Your search selection has resulted in the retrieval of the maximum limit of 10,000 PAR
        records.
        <br />
      </span>
      <span>
        The search results might take longer to load depending on the criteria and the volume of the
        request.
      </span>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="datatable-preheader">
          <h2 class="mt-3">Search Results</h2>
        </div>
      </div>
    </div>
    <div>
      <app-datatable
        [columns]="columns"
        [dataUrl]="dataUrl"
        [queryObject]="searchCriteria"
        [defaultSort]="defaultSort"
        [scrollV]="false"
        [scrollH]="true"
        [preventInitialLoad]="true"
        [disableFiltering]="true"
        (dataLoaded)="enableSearchButton()"
        (requestError)="enableSearchButton()"
        [exportFileName]="'PriorAuthorizationRequestSearch'"
        emptyMessage="There are no Prior Auths to display."
      ></app-datatable>
    </div>
  </section>

  <ng-template #idTemplate let-row="row" let-value="value">
    <a
      class="link--open-new"
      tabindex="0"
      target="_blank"
      [routerLink]="[AppUrls.priorAuthorization.details(row.priorAuthorizationId)]"
    >
      <span class="sr-only">Navigate to Prior Auth</span>
      {{ value | entityFormatter: priorAuthTypeCode }}
      <mat-icon>open_in_new</mat-icon>
      <span class="sr-only">(Link opens in a new window)</span>
    </a>
  </ng-template>
</section>
